import PropTypes from 'prop-types';
import React from 'react';
import FairFiltersBar from '../FairFiltersBar/FairFiltersBar';

const Filters = ({
    allItemsCount,
    promotionsItemsCount,
    clientItemsCount,
    cartItemsCount,
    selectedProductType,
    selectedSuppliers,
    suppliers,
    searchTerm,
    onProductTypeChange,
    onSuppliersChange,
    onSearch,
}) => (
    <FairFiltersBar
        allItemsCount={allItemsCount}
        promotionsItemsCount={promotionsItemsCount}
        clientItemsCount={clientItemsCount}
        cartItemsCount={cartItemsCount}
        selectedProductType={selectedProductType}
        selectedSuppliers={selectedSuppliers}
        suppliers={suppliers}
        searchTerm={searchTerm}
        onProductTypeChange={onProductTypeChange}
        onSuppliersChange={onSuppliersChange}
        onSearch={onSearch}
    />
);

Filters.propTypes = {
    allItemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    promotionsItemsCount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    cartItemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    clientItemsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    selectedProductType: PropTypes.string,
    selectedSuppliers: PropTypes.arrayOf(PropTypes.string),
    suppliers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            description: PropTypes.string,
        })
    ),
    searchTerm: PropTypes.string,
    onProductTypeChange: PropTypes.func,
    onSuppliersChange: PropTypes.func,
    onSearch: PropTypes.func,
};

export default Filters;
